/* eslint-disable */
<div style="max-width:403px;max-height:300px" id="container123"></div>
<template>
  <section class="section section-white content-padded" onload="init()">
    <el-form ref="form" :model="form" label-width="110px">
      <el-form-item label="店铺类型名称">
        <div>
          <el-col :span="8">
            <el-input v-if="edit_name"  v-model="form.shop_type_name" placeholder="店铺类型名称"></el-input>
            <el-input v-else disabled="true" v-model="form.shop_type_name" placeholder="店铺类型名称"></el-input>
          </el-col>
        </div>
      </el-form-item>
      <el-form-item label="类型介绍">
      <div>
        <el-col :span="8"><el-input v-model="form.shop_type_comment" placeholder=""></el-input></el-col>
      </div>
      </el-form-item>
      <el-form-item label="是否启用">
        <el-switch name="status" v-model="form.status" on-text="启用" off-text="禁用"  active-color="#13ce66"  inactive-color="#ff4949"> </el-switch>
      </el-form-item>
      <el-form-item label="排序">
        <div>
          <el-col :span="8"><el-input v-model="form.sort" placeholder=""></el-input></el-col>
        </div>
      </el-form-item>
      <div class="section-footer with-border content-center">
        <el-button size="large" @click="backCancle">取消</el-button>
        <el-button type="primary" @click="submitItemsActionConfirm" :loading="submitLoading">{{submitLoading ? '提交中' : '保存'}}</el-button>
      </div>

    </el-form>
  </section>
</template>
<script>
  import { getShopTypeInfo,saveShopType} from '@/api/marketing'

  export default {
    components: {
    },
    data () {
      return {
         shop_type_id: 0,
          submitLoading:false,
         form:{},
         edit_name:true,
      }
    },
    methods: {
        submitItemsActionConfirm () {
            this.submitLoading = true
            console.log(this.form)

            saveShopType(this.form).then(res => {
                this.submitLoading = false
                this.$message({ type: 'success', message: '保存店铺类型成功'})
                if (this.$store.getters.login_type != 'distributor') {
                    this.$router.go(-1)
                }

            }).catch (error => {
                this.submitLoading = false
            })
        },
        backCancle(){
            this.$router.go(-1)
        },
    },
    mounted () {
      this.shop_type_id = this.$route.query.shop_type_id
      // console.log(this.shop_type_id)
      if (this.shop_type_id) {
          getShopTypeInfo({shop_type_id: this.shop_type_id}).then(res => {
          this.form = res.data.data
          this.edit_name = false
        })
      }
    }

  }
</script>

<style lang="scss">
  .bm-view {
    width: 100%;
    height: 300px;
  }
  #qqmap_rslist {
    border-right: 1px solid #e7e7eb;
  }
  #qqmap_container{
    float:left;
    width:800px;
    height:400px;
  }
  .checkbox {
    background-color: white;
    border-radius: 0px;
    border: 1px solid #d3d3d3;
    width: 20px;
    height: 20px;
    display: inline-block;
    text-align: center;
    vertical-align: bottom;
    line-height: 20px;
  }
</style>



// WEBPACK FOOTER //
// shoptypes_editor.vue?5407a811